import { Address } from '@/api/models/paymentAccountsModels';

export const addressFromString = (formattedAddress: string): Address | undefined => {
  // Regex to extract address, city, state, postal code, and country
  const addressRegex = /^(.*?),\s*(.*?),\s*([A-Z]{2}),?\s+(\d{5}(?:-\d{4})?)(?:,\s*([A-Z]{2,}))?$/;
  const match = formattedAddress.match(addressRegex);

  if (!match) {
    return undefined;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, address, city, state, postal_code, country] = match;

  return {
    address,
    city,
    state,
    postal_code,
    country: country || undefined
  };
};

export const validateAddress = (addressObject?: Address): string | null => {
  if (!addressObject || typeof addressObject !== 'object') return null;

  const normalize = (val: unknown): string | null =>
    typeof val === 'string' && val.trim().length > 0 ? val.trim() : null;

  const address = normalize(addressObject.address);
  const city = normalize(addressObject.city);
  const state = normalize(addressObject.state);
  const postal_code = normalize(addressObject.postal_code);

  if (address && city && state && postal_code) {
    return `${address}, ${city}, ${state}, ${postal_code}`;
  }

  return null;
};
